import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../components/layout/ProtectedRoute.jsx";
import Home from "../pages/Home.jsx";
import Login from "../pages/Login.jsx";
import ProductCreate from "../pages/product/ProductCreate.jsx";
import ProductEdit from "../pages/product/ProductEdit.jsx";
import Products from "../pages/product/Products.jsx";
import Receipt from "../pages/receipt/Receipt.jsx";
import Receipts from "../pages/receipt/Receipts.jsx";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route
          path="/"
          element={<Home />}
        />
      </Route>
      <Route
        path="/login"
        element={<Login />}
      />
      <Route element={<ProtectedRoute />}>
        <Route
          path="/receipts"
          element={<Receipts />}
        />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route
          path="/receipts/:receiptId"
          element={<Receipt />}
        />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route
          path="/products"
          element={<Products />}
        />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route
          path="/products/create"
          element={<ProductCreate />}
        />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route
          path="/products/:productId/edit"
          element={<ProductEdit />}
        />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
